import { useEffect, useState } from 'react';

/** Returns a debounced copy of `value` — only updates after the value has
 * remained unchanged for `delay` ms. Use this to gate expensive API calls
 * (like list + count fetches) off of fast-changing inputs (like text
 * filters) so every keystroke doesn't hammer the backend.
 *
 * @example
 *   const [filters, setFilters] = useState({ name: '' });
 *   const debounced = useDebouncedValue(filters, 500);
 *   useEffect(() => { load(debounced); }, [debounced]);
 */
export function useDebouncedValue(value, delay = 400) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
